import qs from 'qs';
import useSWRMutation from 'swr/mutation';

import { TypeaheadItem } from '@/components/typeahead/typeahead-new.types';
import { AddressRequest } from '@/types/SearchAddressData';
import { AddressResponse, FUZZY_PARAMS } from '@xsf/shared-lib/hooks/location';
import { mapsTokenFetcher } from '@xsf/shared-lib/utils/requests';

const AZ_API_FORMAT = 'json'; // Replace with your actual format if needed

type UseAddressLookupResult = {
  trigger: (query: AddressRequest) => Promise<AddressResponse | undefined>;
  isMutating: boolean;
  data?: AddressResponse;
  error?: Error;
  typeaheadData?: TypeaheadItem[];
};

export const useAddressLookup = (): UseAddressLookupResult => {
  const getUrl = (request: AddressRequest) => {
    const stringParams = qs.stringify(
      { ...FUZZY_PARAMS, ...request },
      { addQueryPrefix: true, arrayFormat: 'comma' }
    );
    // fuzzy or exact search type
    const endpoint = request.useFuzzySearchEndpoint ? 'fuzzy' : 'address';

    return `https://atlas.microsoft.com/search/${endpoint}/${AZ_API_FORMAT}${stringParams}`;
  };

  const { trigger, data, error, isMutating } = useSWRMutation<
    AddressResponse,
    Error,
    string,
    AddressRequest
  >('address-lookup', async (_key, { arg: request }) => {
    // Check if query is null or empty
    if (!request || !request.query || request.query.trim() === '') {
      // Return empty AddressResponse
      return { results: [] } as AddressResponse;
    }

    const url = getUrl(request);
    return mapsTokenFetcher(url);
  });

  return {
    trigger,
    isMutating,
    data,
    error,
  };
};
